import axios from "axios";
// import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";

export default {
  // FAQ page .....................................
  getFAQpage({ dispatch, commit }) {
    axios
      .get("client/Page?name=FAQ")
      .then((res) => {
        commit("setFAQpage", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFaq({ dispatch, commit }) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Faq")
      .then((res) => {
        commit("setFaq", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 800);
      });
  },
};
